import PropTypes from 'prop-types'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { INPUT_KEYS } from '../inputs'
import InputGroup from './InputGroup'

const propTypes = {
  /**
   * callback to decide if input should be displayed or not
   * If return true, input is displayed
   */
  displayInput: PropTypes.func,
  /**
   * Function to render input. Should return a react node. Params: input
   */
  renderInput: PropTypes.func.isRequired,
  /**
   * Placeholder for the add inputs button
   */
  addInputsButton: PropTypes.node,
}

const defaultProps = {
  displayInput: () => true,
  addInputsButton: null,
}

function FormattedPolicyFrame(props) {
  const { displayInput, renderInput, addInputsButton } = props
  const showEnablement = displayInput(INPUT_KEYS.policyStatus)

  return (
    <>
      <Row>
        <Col md="12" className="d-flex justify-content-between mb-4">
          <span className="text-strong">
            <FormattedMessage id="SECURE.ASSIGNMENTS" />
          </span>
          {addInputsButton}
        </Col>
      </Row>
      <div className="px-4">
        <InputGroup
          groupTitle="SECURE.USERS_AND_GROUPS"
          inputs={[
            INPUT_KEYS.includeUsers,
            INPUT_KEYS.excludeUsers,
            INPUT_KEYS.includeGroups,
            INPUT_KEYS.excludeGroups,
            INPUT_KEYS.includeRoles,
            INPUT_KEYS.excludeRoles,
            INPUT_KEYS.includeGuestsOrExternalUsers,
            INPUT_KEYS.excludeGuestsOrExternalUsers,
          ]}
          displayInput={displayInput}
          renderInput={renderInput}
        />
        <InputGroup
          groupTitle="SECURE.CLOUD_APPS"
          inputs={[INPUT_KEYS.includeApplications, INPUT_KEYS.excludeApplications]}
          displayInput={displayInput}
          renderInput={renderInput}
        />
        <InputGroup
          groupTitle="POLICY_TEMPLATES.TARGET_RESOURCES"
          inputs={[INPUT_KEYS.includeUserActions]}
          displayInput={displayInput}
          renderInput={renderInput}
        />
        <InputGroup
          groupTitle="POLICY_TEMPLATES.NETWORKS_AND_LOCATIONS"
          inputs={[INPUT_KEYS.includeLocations, INPUT_KEYS.excludeLocations]}
          displayInput={displayInput}
          renderInput={renderInput}
        />
        <InputGroup
          groupTitle="POLICY_TEMPLATES.DEVICE_PLATFORMS"
          inputs={[INPUT_KEYS.includePlatforms, INPUT_KEYS.excludePlatforms]}
          displayInput={displayInput}
          renderInput={renderInput}
        />
        <InputGroup inputs={[INPUT_KEYS.clientAppTypes]} displayInput={displayInput} renderInput={renderInput} />
        <InputGroup
          groupTitle="POLICY_TEMPLATES.RISKS"
          inputs={[INPUT_KEYS.userRiskLevels, INPUT_KEYS.signInRiskLevels, INPUT_KEYS.insiderRiskLevels]}
          displayInput={displayInput}
          renderInput={renderInput}
        />
        <InputGroup
          groupTitle="POLICY_TEMPLATES.AUTH_FLOWS"
          inputs={[INPUT_KEYS.transferMethods]}
          displayInput={displayInput}
          renderInput={renderInput}
        />
      </div>

      <hr className="mb-4" />

      <Row>
        <Col md="12" className="text-strong mb-4">
          <FormattedMessage id="POLICY_TEMPLATES.ACCESS_CONTROLS" />
        </Col>
      </Row>
      <div className="px-4">
        <InputGroup
          groupTitle="SECURE.GRANT"
          inputs={[
            INPUT_KEYS.builtInControls,
            INPUT_KEYS.authenticationStrength,
            INPUT_KEYS.customAuthenticationFactors,
            INPUT_KEYS.grantControlsOperator,
          ]}
          displayInput={displayInput}
          renderInput={renderInput}
        />
      </div>

      {showEnablement && (
        <>
          <hr className="mb-4" />

          <Row>
            <Col md="12" className="text-strong mb-4">
              <FormattedMessage id="SECURE.ENABLEMENT" />
            </Col>
          </Row>
          <div className="px-4">
            <InputGroup inputs={[INPUT_KEYS.policyStatus]} displayInput={displayInput} renderInput={renderInput} />
          </div>
        </>
      )}
    </>
  )
}

FormattedPolicyFrame.propTypes = propTypes
FormattedPolicyFrame.defaultProps = defaultProps

export default FormattedPolicyFrame
